import { FaqForm } from './FaqForm';
import { FaqParentProps, PageStatus } from './types';

type Props = FaqParentProps & {
    changePage: (status: PageStatus) => void;
    onSaved: () => void;
};

export const CreateFaq = ({ changePage, onSaved, ...parentProps }: Props) => (
    <FaqForm
        {...parentProps}
        onCancel={() => changePage(PageStatus.MAIN)}
        onSaved={onSaved}
    />
);
